module.exports = require('./components/Modal');




/*****************
 ** WEBPACK FOOTER
 ** ./~/react-modal/lib/index.js
 ** module id = 916
 ** module chunks = 1
 **/